import { Box, CircularProgress } from '@mui/material';
import React from 'react';
import { variantMapping } from './variants';

const LoadingCircular = ({ value, variant, showPercentage }) => (
  <Box sx={{ position: 'relative', display: 'inline-flex' }}>
    <CircularProgress
      size={variantMapping[variant].size}
      sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: '-12px',
        marginLeft: '-12px',
        color: variantMapping[variant].color,
        cursor: 'initial',
      }}
    />
    {showPercentage && (
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <div style={{ fontSize: '8px', color: variantMapping[variant].color }}>
          {value || 0}%
        </div>
      </Box>
    )}
  </Box>
);

export default LoadingCircular;
